module.exports = __webpack_public_path__ + "img/tolet.5e0ae5b9.svg";